/** Public branded-app legal pages (privacy policy, terms of service). */
export const CP_PUBLIC_LEGAL_ROUTE_PREFIX = '/legal/' as const

export const isCPLegalRoutePath = (path?: string): boolean => typeof path === 'string' && path.startsWith(CP_PUBLIC_LEGAL_ROUTE_PREFIX)

/** Pilot locations that may serve `/legal/*`. All other locations 404. */
export const CP_LEGAL_PAGES_LOCATION_IDS = ['lDWMU21RdnuIxcZsI8A1', 'hMDUTOU6bIG4hXRzXQKm'] as const

export const CP_LEGAL_PAGES_LOCATION_IDS_SET = new Set<string>(CP_LEGAL_PAGES_LOCATION_IDS)

export const isCPLegalPagesLocation = (locationId?: string): boolean =>
  typeof locationId === 'string' && CP_LEGAL_PAGES_LOCATION_IDS_SET.has(locationId)
